import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import * as moment from 'moment';
import { UserService } from '../../../../../auth/user.service';
import { PlinksDashboardService } from '../plinks-dashboard.service';
import { DevicesDashboardService } from '../../../devices/devices-dashboard.service';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { NotificationMessageService } from '../../../../../shared/notification-message/notification-message.service';

@Component({
	selector: 'app-select-plink',
	templateUrl: './select-plink.component.html',
	styleUrls: ['./select-plink.component.css']
})
export class SelectPlinkComponent implements OnInit {

	@Input() plink: any = {};
	@Input() plinkID: number;
	@Input() customerID: number = 0;
	@Input() siteID: number = 0;
	@Input() multipleOptions: boolean = false;
	@Input() activePage: string;
	@Input() analyticsTab: string;
	@Input() currentSite: any;
	@Input() showElementsFlags: any = {};

	currentUser: any = {};
	plinksIDs: any = [];
	fromDateFmt: Date;
	toDateFmt: Date;
	sitePlinks: any = [];
	siteTags: any = [];
	siteGroups: any = [];
	deviceTags: any = [];
	showDateRange: boolean = false;

	@Output() onPlinkSelect = new EventEmitter<Object>();
	@Output() onDatesChanged = new EventEmitter<Object>();
	@Output() onGetSitePlinks = new EventEmitter<boolean>();

	constructor(
		private userService: UserService,
		private route: ActivatedRoute,
		private router: Router,
		private location: Location,
		private commonUtil: CommonUtil,
		private plinksDashboard: PlinksDashboardService,
		private devicesDashboard: DevicesDashboardService,
		private notificationMessage: NotificationMessageService
	) { }

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();

		if(this.plinkID == 0) this.plinkID = null;

		this.getSitePlinks(this.plinkID);

		// If we have a plinkID from the URL but no device info, get it for display
		// Note: Settings tab also needs device info for proper dropdown population
		if(this.plinkID && !this.plink) {
			setTimeout(() => {
				this.getCachedPlinks();
			}, 500); // Wait a bit for getSitePlinks to complete first
		}

		if(['connectivity-track', 'debug-records'].indexOf(this.activePage) != -1 || this.activePage == 'plink-events' || this.activePage == 'rt-records')
			this.showDateRange = true;
		else
			this.showDateRange = false;

		if(this.showDateRange) {
			switch(this.activePage) {
				case 'connectivity-track':
					this.fromDateFmt	= new Date(moment().utc().subtract(1, 'days').startOf('day').unix() * 1000);
				break;
				case 'debug-records':
					this.fromDateFmt	= new Date(moment().utc().subtract(6, 'days').startOf('day').unix() * 1000);
				break;
				case 'plink-events':
					this.fromDateFmt	= new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(0, 0, 0, 0));
				break;
				case 'rt-records':
					this.fromDateFmt	= new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(0, 0, 0, 0));
				break;
				case 'analytics':
					this.fromDateFmt	= new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(0, 0, 0, 0));
				break;
				default:
					this.fromDateFmt	= new Date(new Date(new Date().setMonth(new Date().getMonth() - 3)).setHours(0, 0, 0, 0));
				break;
			}
			this.toDateFmt		= new Date(new Date().setHours(23,59,59,999));
			this.datesChanged();
		}
	}



	refreshDropdownSelection() {
		// Simple refresh method - consistent routing makes this much simpler
		if(this.plinkID && this.sitePlinks && this.sitePlinks.length > 0) {
			const selectedPlink = this.sitePlinks.find(plink => plink.deviceid === this.plinkID);
			if(selectedPlink) {
				this.getCachedPlinks();
			}
		}
	}

	// Method to be called by parent component when needed (mainly for returning from external pages)
	forceRefreshSelection() {
		if(this.plinkID && this.sitePlinks && this.sitePlinks.length > 0) {
			const selectedPlink = this.sitePlinks.find(plink => plink.deviceid === this.plinkID);
			if(selectedPlink) {
				// Simple refresh by temporarily clearing and resetting
				const currentPlinkID = this.plinkID;
				this.plinkID = null;
				setTimeout(() => {
					this.plinkID = currentPlinkID;
				}, 10);
			}
		} else if(this.plinkID && (!this.sitePlinks || this.sitePlinks.length === 0)) {
			this.getSitePlinks(this.plinkID);
		}
	}



	getSitePlinks(checkDeviceId) {

		var plinkInfo = {
			'customerid':	this.customerID,
			'siteid':		this.siteID
		};

		this.plinksDashboard.getPlinks(plinkInfo, {'getTags': true, 'getGroups': this.currentSite.act_first_enabled, checkDeviceId: checkDeviceId}).subscribe(
			(plinks: any) => {

				plinks.list.forEach((plink) => {
					plink['prettyName'] = plink['serialnumber'] + ' (ID: ' + plink['deviceid'] + ')';
				});

				this.sitePlinks = plinks.list.sort((a:any, b:any) => {return a.serialnumber.localeCompare(b.serialnumber, undefined, {numeric: true});});
				this.siteTags	= plinks.tags.siteTags;
				this.siteGroups	= plinks.groups || [];



				let deviceTags = {};

				this.sitePlinks.forEach((item) => {
					deviceTags[item.deviceid] = [];
					if(plinks.tags.deviceTags[item.deviceid]) {
						plinks.tags.deviceTags[item.deviceid].forEach((tagItem) => {
							if(this.siteTags[tagItem.tagid]) {
								let deviceTag = Object.assign({}, this.siteTags[tagItem.tagid]);
								deviceTag.keep_in_replacement = tagItem.keep_in_replacement;
								deviceTags[item.deviceid].push(deviceTag);
							}
						});
					}
				});

				this.deviceTags	= deviceTags;

				this.onGetSitePlinks.emit(this.sitePlinks.length > 0);

				if(this.plinkID){
					if(plinks.checkDeviceStatus && plinks.checkDeviceStatus.status){
						switch(plinks.checkDeviceStatus.status){
							case 'replaced':
								this.router.navigate(["/", this.customerID, this.siteID, "plinks", "analytics", "rt-records", plinks.checkDeviceStatus.extra]);
							break;
							case 'moved':
								this.notificationMessage.setMessage('Device has been moved to other site, for more information please contact ACT person.', 'warning');
							break;
							case 'deleted':
								this.notificationMessage.setMessage('The device has been deleted.', 'warning');
							break;
							}
					} else {
						// Always get cached plinks data for proper dropdown population
						// This ensures the selected device is properly displayed in all tabs including Settings
						this.getCachedPlinks();
					}
				}
			}
		);
	};

	getCachedPlinks() {
		this.plinksDashboard.getCachedPlinks(this.plinkID).subscribe(
			(plink: any) => {
				this.plink = plink;
				this.onPlinkSelect.emit(this.plink);
			},
			(error) => {
				console.warn('SelectPlink getCachedPlinks() error:', error);
			}
		);
	}



	datesChanged() {
		let dates = {
			'fromDateFmt':	this.fromDateFmt,
			'toDateFmt':	this.toDateFmt
		};
		this.onDatesChanged.emit(dates);
	}

	plinkChanged() {
		let url: any[] = [this.activePage];
		let queryParams = {};

		// Use consistent URL path format for all tabs (matching Settings, Notes pattern)
		if(this.activePage == 'analytics')
			url.push(this.analyticsTab, this.plinkID);
		else if(this.activePage == 'notes')
			url.push(this.plinkID);
		else if(this.activePage == 'settings')
			url.push(this.plinkID);
		else if(this.activePage == 'quick-view')
			url.push(this.plinkID);
		else if(this.activePage == 'plink-events')
			url.push(this.plinkID);
		else if(this.activePage == 'rt-records')
			url.push(this.plinkID);
		else
			queryParams = {'plinksIDs': this.plinkID}; // Fallback for other tabs

		this.location.go(
			this.router.createUrlTree(
				url,
				{'relativeTo': this.route.parent, 'queryParams': queryParams}
			).toString()
		);

		// All tabs now work the same way - get cached plink data and emit the full object
		this.getCachedPlinks();
	}

	updateTags(event) {
		if (event.type == 'add') {
			this.deviceTags[this.plinkID].push(event.tag);
			if(!this.siteTags[event.tag.id]) {
				this.siteTags[event.tag.id] = event.tag;
			}
		} else {
			// remove
			let removedTagId = event.tag.id;
			let deviceTag = [];
			this.deviceTags[this.plinkID].forEach((tag) => {
				if(tag.id != removedTagId) {
					deviceTag.push(tag);
				}
			})
			this.deviceTags[this.plinkID] = deviceTag;
		}
	}

	addGroup(group) {
		this.devicesDashboard.assignDeviceToGroup(this.siteID, group.id, 'plink', this.plinkID).subscribe((res) => {
			this.notificationMessage.setMessage(res, 'success', 10000, true);
		});
	}
}
